import { render } from "./RadarChart.vue?vue&type=template&id=49b96a5d&scoped=true"
import script from "./RadarChart.vue?vue&type=script&lang=js"
export * from "./RadarChart.vue?vue&type=script&lang=js"

import "./RadarChart.vue?vue&type=style&index=0&id=49b96a5d&scoped=true&lang=css"
/* custom blocks */
import block0 from "./RadarChart.vue?vue&type=custom&index=0&blockType=template2"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b96a5d"]])

export default __exports__